const DocumentActions = {
  None: 0,
  Added: 1,
  Removed: 2,
  RemoveFromView: 10 // only for internal purpose
}
export default DocumentActions;
